import { AddressCell } from '@/components/ui'
import { InsightConfigurationType, LatLng, AlertData } from '@/types/dashboard-types'

import { duration, interval } from './formatUtils'

import { getSeverityLabel } from '../components/SeverityDropdown'

const typeMap = {
  raised: { field: 'raisedLocation', title: 'Raised', address: 'address' },
  cleared: { field: 'clearedLocation', title: 'Cleared', address: 'address' },
  raisedGeofence: { field: 'raisedGeofence', title: 'Raised Geofence', address: 'name' },
}

const AlarmLocationDrilldown = (
  alert: AlertData,
  configuration: InsightConfigurationType,
  type: 'raised' | 'cleared' | 'raisedGeofence',
  companyId?: number
) => {
  const t = typeMap[type]
  const loc = alert[t.field as keyof AlertData] as LatLng
  if (!loc) {
    return 'N/A'
  }
  if (!loc?.latitude && !loc?.longitude) {
    return loc[t.address as keyof typeof loc] || 'N/A'
  }

  return {
    id: `${type}-${alert.id}`,
    address: loc[t.address as keyof typeof loc] || 'N/A',
    lat: loc.latitude,
    lng: loc.longitude,
    companyId: alert.company.id || companyId,
    title: `${configuration.title}: ${alert.asset.name} (${t.title} Location)`,
    markerContent: (
      <div>
        <div>Asset: {alert.asset.name}</div>
        <div>Alert: {alert.alertName}</div>
        <div>Severity: {getSeverityLabel(String(alert.severity))}</div>
        <div>Raised: {alert.raisedTime.toLocaleString()}</div>
        <div>Cleared: {alert.clearedTime ? alert.clearedTime.toLocaleString() : 'Active'}</div>
        <div>
          Duration: {alert.clearedTime ? interval(alert.raisedTime, alert.clearedTime) : duration(alert.raisedTime)}
        </div>
      </div>
    ),
  } as AddressCell
}

export default AlarmLocationDrilldown
